import { Bar } from "react-chartjs-2";
import styled from "styled-components";
import React, { Fragment, useEffect, useState } from "react";
import {
  Grid,
  Typography,
  LinearProgress,
  Paper as MuiPaper,
} from "@mui/material";
import {
  Title,
  Legend,
  Tooltip,
  BarElement,
  LinearScale,
  CategoryScale,
  Chart as ChartJS,
} from "chart.js";

import { useComponent } from "../../../hooks";
import startDateCalculator from "./startDateCalculator";

ChartJS.register(
  Title,
  Legend,
  Tooltip,
  BarElement,
  LinearScale,
  CategoryScale
);

const Paper = styled(MuiPaper)`
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 10px;
`;

const ContainerItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export default function MessagesDisplayOne({ startDate, botID }) {
  const { axios } = useComponent();
  const [loading, setLoading] = useState(true);
  const [messageDisplay, setMessageDisplay] = useState({});

  useEffect(() => {
    setLoading(true);

    axios({
      url: `/insights/messaging_graphs/${botID}`,
      disableError: true,
      disableRedirect: true,
      params: {
        end_date: new Date().getTime() / 1000,
        ...(startDate !== -1 && { start_date: startDateCalculator(startDate) }),
      },
    }).then((response) => {
      if (response.status) {
        setMessageDisplay({
          labels: response.data.labels,
          datasets: response.data.dataset,
          borderColor: response.data.dataset[0].border_color,
        });

        setLoading(false);
      }
    });
  }, [axios, botID, startDate]);

  const options = {
    indexAxis: "x",
    elements: {
      bar: {
        borderWidth: 0,
      },
    },
    responsive: true,
    interaction: {
      mode: "index",
      intersect: false,
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
    plugins: {
      legend: {
        position: "top",
      },
    },
  };

  return (
    <Paper style={{ height: { lg: "390px", sm: "350px" } }}>
      {loading ? (
        <LinearProgress style={{ width: "80%" }} />
      ) : (
        <Fragment>
          <Container>
            <Grid
              container
              spacing={2}
              style={{ justifyContent: "center", alignItems: "center" }}
            >
              <Grid
                item
                xs={8}
                sm={10}
                md={12}
                lg={12}
                xl={11}
                style={{ justifyContent: "center", alignItems: "center" }}
              >
                <ContainerItem>
                  <Typography
                    variant="h5"
                    sx={{
                      fontSize: { lg: 17, md: 17, sm: 17, xs: 15 },
                      alignItems: "center",
                    }}
                  >
                    Total Message
                  </Typography>

                  <Bar data={messageDisplay} options={options} />
                </ContainerItem>
              </Grid>
            </Grid>
          </Container>
        </Fragment>
      )}
    </Paper>
  );
}
